import { createContext, Dispatch, SetStateAction } from 'react';
import { Nullable } from '../../utilities/common_types';

export enum AppState {
  inactive = 'inactive',
  active = 'active',
}

interface AppStateContextType {
  readonly status: AppState;
  readonly isInitialised: boolean;
  readonly setIsInitialised: Dispatch<SetStateAction<boolean>>;
}

export const AppStateContext = createContext<Nullable<AppStateContextType>>(null);
